export const USERNAME = 'ibrahimkhurshid'
export const NAME = 'Ibrahim Khurshid'
export const AVATAR_URL = 'https://avatars.githubusercontent.com/u/99968063?v=4'
export const EMAIL = 'ibrahimkhurshid@hotmail.com'
export const LINKEDIN_PROFILE = 'https://www.linkedin.com/in/ibrahimkhurshid'
export const LOCATION = 'Lahore, Pakistan'
export const CALENDLY_URL = 'https://calendly.com/ibrahimkhurshid'

export const ABOUT_ME_MARKDOWN = `
Hi, I'm Ibrahim.

I am a Software Engineer with 5+ years of commercial experience in IT, currently focused on backend and full-stack development.

I am passionate about building software that improves the lives of those around me, also really excited about Open Source Software.

I have a diverse set of skills, ranging from front-end, all the way to back-end and databases.
`

export const WEBSITE_URL = 'https://ibrahimkhurshid.github.io'

export const EXPERIENCES = [
  {
    starting: 'January 2026',
    ending: null,
    company: 'Codebricks',
    jobDescription: `Maintained and enhanced existing full-stack applications built with React.js, Node.js, NestJS, and MongoDB. 
Managed frequent deployments and CI/CD pipelines using GitLab, including automated scripts and shell-based tooling. 
Developed internal TUI (Text-based User Interface) tools to streamline routine operations and monitoring tasks. 
Collaborated with cross-functional teams to ensure system stability, seamless integration, and feature continuity across multiple client projects.`,
  technologies: [
    'React.js',
    'Node.js',
    'NestJS',
    'Sails.js',
    'GraphQL',
    'MongoDB',
    'PostgreSQL',
    'Ant Design',
    'GitLab CI/CD',
    'AI-assisted development',
    'Shell scripting',
    'TUI internal tools'
  ],
    jobTitle: 'Senior Software Engineer'
  },
  {
    starting: 'November 2023',
    ending: 'December 2025',
    company: 'Gigalabs',
    jobDescription: `Developed scalable full-stack web applications with React.js, Node.js, NestJS, and MongoDB. 
Designed and implemented REST and GraphQL APIs to deliver flexible and efficient data services. 
Integrated Ant Design components to build clean, responsive UIs. 
Contributed to Sails.js backend services and managed GitLab CI/CD pipelines for smooth deployments. 
Collaborated within agile teams to deliver client features on time while ensuring consistent API design and seamless frontend-backend integration.`,
    technologies: [
      'React.js',
      'Node.js',
      'NestJS',
      'Sails.js',
      'GraphQL',
      'MongoDB',
      'PostgreSQL',
      'Ant Design',
      'GitLab CI/CD'
    ],
    jobTitle: 'Software Engineer'
  },

  {
    starting: 'June 2022',
    ending: 'October 2023',
    company: 'Gigalabs',
    jobDescription: `Worked as an Associate Software Engineer on web applications with a focus on frontend and backend development. 
Built responsive and interactive user interfaces using React.js and Styled Components. 
Developed and maintained scalable backend services and REST APIs using NestJS, ensuring efficient data delivery and integration with frontend components. 
Followed best practices for version control, collaboration, and code reviews using Git. 
Collaborated with cross-functional teams in an agile environment to deliver client-focused features on time.`,
    technologies: ['ReactJs', 'NestJS', 'REST API', 'Styled Components', 'Git'],
    jobTitle: 'Associate Software Engineer'
  },
  {
    starting: 'February 2020',
    ending: 'May 2022',
    company: 'Quid Sol',
    jobDescription: `Handled data preprocessing, feature engineering, and model evaluation for machine learning projects. 
Developed ML models using Python, Scikit-learn, and OpenCV for computer vision and classification tasks. 
Built proof-of-concept applications such as a real-time lipstick try-on mirror and a gesture-based Tic Tac Toe game using facial landmark detection and image processing.`,
    technologies: [
      'tensorflow',
      'Keras',
      'PyTorch',
      'Flask',
      'Django',
      'Python',
      'OpenCV',
      'Scikit-learn',
      'MediaPipe',
      'NumPy',
      'Pandas',
      'git'
    ],
    jobTitle: 'Machine Learning Associate'
  },
  {
    starting: 'September 2019',
    ending: 'January 2020',
    company: 'Codenya',
    jobDescription: `Worked as an Associate Web Developer focusing on building and maintaining basic web pages and static websites. 
Used HTML5, CSS3, and JavaScript to implement responsive layouts and interactive features. 
Collaborated with senior developers to assist in integrating frontend components with backend services.`,
    technologies: ['HTML5', 'CSS3', 'JavaScript', 'Bootstrap', 'Wordpress'],
    jobTitle: 'Web Developer'
  }
]

export const EDUCATION = [
  {
    starting: '2015',
    ending: '2019',
    degree: 'Bachelors of Computer Science',
    institute: 'University of Sargodha',
    shortCode: 'UOS'
  },
  {
    starting: '2012',
    ending: '2014',
    degree: 'FSC Pre-Engineering',
    institute: 'Superior College Sargodha',
    shortCode: 'SGC'
  }
]
